import { render, staticRenderFns } from "./PrestPagination.vue?vue&type=template&id=7e6868b3&"
import script from "./PrestPagination.vue?vue&type=script&lang=ts&"
export * from "./PrestPagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports